import * as styled from '../styles/reputation-panel';

const STAR_COUNT = 5;

type Props = {
  stat: LandingV2.StatPanel;
  accentColor?: string | null;
};

export const ReputationPanel = ({ stat, accentColor }: Props) => (
  <styled.Panel $accentColor={accentColor}>
    <styled.CountRow>
      <styled.CountValue $accentColor={accentColor}>{stat.countValue}</styled.CountValue>
      <styled.Label $accentColor={accentColor}>{stat.countLabel}</styled.Label>
    </styled.CountRow>
    <styled.Divider $accentColor={accentColor} />
    <styled.Label $accentColor={accentColor}>Reputation score</styled.Label>
    <styled.ScoreRow>
      <styled.Score $accentColor={accentColor}>{stat.score}</styled.Score>
      <styled.ScoreDetails>
        <styled.Stars>{'★'.repeat(STAR_COUNT)}</styled.Stars>
        <styled.ReviewCount $accentColor={accentColor}>
          Based on {stat.reviewCount} reviews
        </styled.ReviewCount>
      </styled.ScoreDetails>
    </styled.ScoreRow>
  </styled.Panel>
);
